module.exports = {
    en: {
        lounge: {
            car: 'Cars',
        }

    },
    ka: {
        lounge: {
            car: 'მანქანები',
        }
    },
    ru: {
        lounge: {
            car: 'автомобили',
        }
    }
}